import { BaseUrlService } from './base-url.service';

export class CodiceDestinatarioService {
    static $inject: string[] = ['$http', 'BaseUrlService', '$q'];

    private baseUrl: any;
    private codiceDestinatario: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
        private $q: any
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    assignCodiceDestinatario(code?: any) {
        return this.$http.post(this.baseUrl + '/fattura-elettronica/passiva/assign-codice-destinatario', code);
    }

    getCodiceDestinatario() {
        return this.$http.get(this.baseUrl + '/fattura-elettronica/passiva/codice-destinatario/get');
    }

    valoreCodiceDestinatario() {
        return this.codiceDestinatario;
    }

    impostaCodiceDestinatario(codDest: any) {
        this.codiceDestinatario = codDest;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/codice-destinatario.service.ts